import React, { Component } from 'react';
import { UserInstructions } from './componentChildren/UserInstructions';
import './css/SessionPrep.css'

export class SessionPrep extends Component {

    constructor(props) {
        super(props);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.disableSubmitButton = this.disableSubmitButton.bind(this);
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.value;

        this.props.updateScanTote(value);
    }

    disableSubmitButton() {
        var disableButton = false;
        if (!this.props.repick) {
            if (!this.props.queue) {
                disableButton = true;
            }
        }
        if (this.props.totes.length === 0 && !this.props.batchId) {
            disableButton = true;
        }
        if (!this.props.location.locationId || this.props.location.locationId == -1) {
            disableButton = true;
        }
        return disableButton;
    }

    render() {
        var removeScannedToteFunction = this.props.removeScannedTote;
        var removeAllScannedTotesFunction = this.props.removeAllScannedTotes;
        var totes = this.props.totes;
        var repickList = this.props.repickList;
        var slotList = this.props.slotList;
        var disableSubmitButton = this.disableSubmitButton();
        var repick = this.props.repick;
        var userPermissions = this.props.userPermissions;
       
        return (
            <div className="sessionPrep">
                <UserInstructions
                    instructions={this.props.instructions}
                />
                <form action="#">
                <input className="scanIdentifierInput" autoComplete="off" type="text" id="scanInput" name="scanInput" placeholder="Scan or Enter Tote #" value={this.props.scannedToteInput} onChange={this.handleInputChange}></input>
                    <button hidden type="submit" onClick={this.props.addScannedTote} />
                </form>      
                {
                    totes.length > 0 &&
                    <div>
                        <table className="scannedToteTable">
                            <thead>
                                <tr>
                                    <th>Tote #</th>
                                    <th>Slot #</th>
                                    <th className="remove"><i className="fa fa-trash" aria-hidden="true">Remove <b onClick={() => removeAllScannedTotesFunction()}>X</b></i></th>
                                </tr>
                            </thead>
                            <tbody>
                            {totes.map(function (Tote, idx) {
                                return (
                                    <tr key={idx}>
                                        <td>{Tote}</td>
                                        <td>{slotList[Tote]}</td>
                                        <td className="remove"><b onClick={() => removeScannedToteFunction(Tote)}>X</b></td>
                                    </tr>
                                )
                            })}
                            </tbody>
                        </table>
                    </div>
                }
                <div className="submitDiv">
                    <div className="repickCheckbox">
                        <label>
                            Pick Totes Already in Process:  
                            <input
                                name="repick"
                                type="checkbox"
                                value={this.props.repick}
                                onChange={this.props.changeRepick} />
                        </label>
                    </div>
                    <select disabled={this.props.repick} className="queueSelect" value={this.props.queue.id} onChange={this.props.updateQueue}>
                        <option key={-1} value="" defaultValue>-Select Queue-</option>
                        {
                            this.props.queues.map(function (queue, idx) {
                                var userHasPermission = true;
                                var queuePermissions = queue.permissions;
                                if (queuePermissions) {
                                    var queuePermissionsArray = queuePermissions.split(",");
                                    for (var i = 0; i < queuePermissionsArray.length; i++) {
                                        var queuePermission = queuePermissionsArray[i];
                                        if (userPermissions.indexOf(queuePermission) == -1) {
                                            userHasPermission = false;
                                            break;
                                        }
                                    }
                                }
                                if (queue.qty > 0 && userHasPermission) {
                                    return (<option key={idx} value={queue.id}>{queue.name} - {queue.qty}</option>)
                                }
                            })}
                    </select>
                    <select className="locationSelect" value={this.props.location.locationId} onChange={this.props.updateLocation}>
                        <option key={-1} value="" defaultValue>-Select Picking Location-</option>
                        {
                            this.props.locations.map(function (location, idx) {
                                return (<option key={idx} value={location.locationId}>{location.locationName}</option>)
                            })}
                    </select>
                    <button
                        className='tote-submit'
                        disabled={disableSubmitButton}
                        onClick={() => this.props.submitTotes()}>
                        Begin
                    </button>
                    <div>
                        <br />
                        <h3>Repick Totes (Ordered by Priority)</h3>
                        <table className="repickTotes">
                            <th>Tote</th>
                            <th>Slot</th>
                            {repickList.map(function (ToteInfo, idx) {
                                return (
                                    <tr key={idx}>
                                        <td>{ToteInfo.toteId}</td>
                                        <td>{ToteInfo.slot}</td>
                                    </tr>
                                )
                            })}
                        </table>
                    </div>
                </div>
            </div>
        );
    }
}
